module.exports = __webpack_public_path__ + "static/media/optiqueSecondary.bbdf17e8.svg";